// TypeScript interfaces for Job Closing Survey

export interface Job {
  id: number;
  job_title: string;
  job_type?: {
    title: string;
  };
  created_at: string;
}

export type OutcomeType = 
  | 'hired_through_platform'
  | 'filled_another_source'
  | 'no_longer_hiring'
  | 'no_qualified_candidates'
  | 'still_hiring'
  | 'other';

export interface JobClosingSurveyData {
  job_id: number;
  outcome: OutcomeType;
  outcome_other?: string;
  additional_comments?: string;
  recommendation_score?: number; // 0-10 NPS score
}

export interface JobClosingSurveyProps {
  job: Job;
  isVisible: boolean;
  onClose: () => void;
  onSuccess?: (message: string) => void;
  onError?: (error: string) => void;
}

export interface ValidationErrors {
  outcome?: string;
  outcome_other?: string;
  general?: string;
}

export interface JobClosingSurveyState {
  formData: JobClosingSurveyData;
  validationErrors: ValidationErrors;
  isSubmitting: boolean;
  showOtherInput: boolean;
  touched: {
    outcome: boolean;
    outcome_other: boolean;
    additional_comments: boolean;
    recommendation_score: boolean;
  };
}

export const OUTCOME_OPTIONS = [
  {
    value: 'hired_through_platform' as OutcomeType,
    label: 'We hired someone through your platform'
  },
  {
    value: 'filled_another_source' as OutcomeType,
    label: 'We filled the role through another source'
  },
  {
    value: 'no_longer_hiring' as OutcomeType,
    label: "We're no longer hiring for this position"
  },
  {
    value: 'no_qualified_candidates' as OutcomeType,
    label: "We didn't find qualified candidates"
  },
  {
    value: 'still_hiring' as OutcomeType,
    label: "We're still hiring but closing this posting"
  },
  {
    value: 'other' as OutcomeType,
    label: 'Other'
  }
];

export const NPS_CATEGORIES = {
  DETRACTOR: 'detractor', // 0-6
  PASSIVE: 'passive', // 7-8
  PROMOTER: 'promoter' // 9-10
} as const;

export function getNPSCategory(score: number): keyof typeof NPS_CATEGORIES {
  if (score <= 6) return 'DETRACTOR';
  if (score <= 8) return 'PASSIVE';
  return 'PROMOTER';
}

export interface QuickCloseData {
  job_id: number;
  outcome: OutcomeType;
  outcome_other?: string;
}

export interface UserPreference {
  skip_job_closing_survey: boolean;
}